import { render, staticRenderFns } from "./label-recycle-modal.vue?vue&type=template&id=e288fab4"
import script from "./label-recycle-modal.vue?vue&type=script&lang=js"
export * from "./label-recycle-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports